import React, { useState } from 'react'
import StatusPill from '../../home/widgets/statusPill'
import { Spinner, toaster } from 'evergreen-ui';
import { gql,useMutation} from '@apollo/client';
// import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';


export const STATUS_CHANGE = gql`
mutation Complaint_resolve($complaintResolveId: ID!, $status: ComplaintStatus!) {
  complaint_resolve(id: $complaintResolveId, status: $status) {
    code
    success
    error
  }
}
`;

function ChangeComplaintStatus(props) {
const data = props.dataRes
console.log(data)
// const history = useHistory()
const [changeStatus, { loading }] = useMutation(STATUS_CHANGE);

const statusChange=(stat)=>{
    console.log("clckccy",stat)
    
    changeStatus({
      variables: { 
        complaintResolveId: data.id,
        status: stat,
      },
    })
    .then((response) => {
      toaster.notify("Status changed")
      window.location.reload()
    //   history.push(`/complaintById/${data._id}`)
    })
    .catch((error) => {
      toaster.danger(error.message)
    });
  }
const [open,setOpen] = useState(false)
    return (
    <div>
        <div style={{
            display:"flex"
        }} onClick={()=>setOpen(!open)}>
            <StatusPill status={data.status}/> 
            <i className='material-icons'>
                
                {!open?'expand_more':'expand_less'}
            </i>

            
        </div>
            {open ?
            <div data-aos="zoom-down">{loading
                    ?<Spinner/>
                    :<div>
                        <div style={{
                            marginBottom:"5px"
                        }}></div>

                        <div onClick={()=>{
                            // console.log("ds")
                            statusChange("unfixed")
                        }}>
                            <StatusPill status="unfixed"  
                            />
                        </div>
                        <div style={{
                            marginBottom:"5px"
                        }}></div>
                        <div onClick={()=>{
                            // console.log("ds")
                            statusChange("fixed")
                        }}>
                            <StatusPill status="fixed" />
                        </div>
                    </div> 
                }</div>:''
            }
    </div>
  )
}

export default ChangeComplaintStatus